import React from "react";
import PageHero from "../../../components/shared/PageHero";
import SurfaceCard from "../../../components/shared/SurfaceCard";
import StatusBadge from "../../../components/shared/StatusBadge";
import UserProfileService from "../../../services/UserProfileService";
import "../../../styles/screens/marketplace/admin/SellerApprovals.css";

const formatDateTime = (value) => {
  if (!value) {
    return "N/D";
  }

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "N/D";
  }

  return new Intl.DateTimeFormat("it-IT", {
    timeZone: "Europe/Rome",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(date);
};

class SellerApprovals extends React.Component {
  state = {
    isLoading: true,
    sellers: [],
    error: "",
    actionUserId: "",
  };

  componentDidMount() {
    this.loadSellers();
  }

  componentDidUpdate(prevProps) {
    const previousRefreshAt = prevProps.location?.state?.refreshSellerApprovalsAt;
    const currentRefreshAt = this.props.location?.state?.refreshSellerApprovalsAt;

    if (currentRefreshAt && currentRefreshAt !== previousRefreshAt) {
      this.loadSellers();
    }
  }

  loadSellers = async () => {
    this.setState({
      isLoading: true,
      error: "",
    });

    try {
      const sellers = await UserProfileService.listSellerApprovals(false);
      this.setState({
        isLoading: false,
        sellers: Array.isArray(sellers) ? sellers : [],
        actionUserId: "",
      });
    } catch (error) {
      this.setState({
        isLoading: false,
        error:
          error?.response?.data?.detail ||
          "Impossibile caricare l'elenco dei venditori.",
      });
    }
  };

  onUpdateApproval = async (seller, approved) => {
    this.setState({
      actionUserId: seller.id || seller._id,
      error: "",
    });

    try {
      await UserProfileService.updateSellerApproval(
        seller.id || seller._id,
        approved
      );
      await this.loadSellers();
    } catch (error) {
      this.setState({
        actionUserId: "",
        error:
          error?.response?.data?.detail ||
          "Aggiornamento approvazione non riuscito.",
      });
    }
  };

  renderSellerCard = (seller) => {
    const sellerId = seller.id || seller._id;
    const isUpdating = this.state.actionUserId === sellerId;
    const fullName =
      [seller.firstName, seller.lastName].filter(Boolean).join(" ").trim() ||
      seller.email;

    return (
      <SurfaceCard key={sellerId} className="seller-approval-card">
        <div className="seller-approval-card__header">
          <div>
            <span className="seller-approval-card__eyebrow">Venditore</span>
            <h4>{fullName}</h4>
            <p>{seller.email}</p>
          </div>
          <StatusBadge tone={seller.isSellerApproved ? "success" : "warning"}>
            {seller.isSellerApproved ? "Abilitato" : "In attesa"}
          </StatusBadge>
        </div>

        <div className="seller-approval-card__meta">
          <div>
            <span>Email verificata</span>
            <strong>{seller.emailVerified ? "Si" : "No"}</strong>
          </div>
          <div>
            <span>Ultimo invio verifica</span>
            <strong>{formatDateTime(seller.verificationEmailSentAt)}</strong>
          </div>
          <div>
            <span>Indirizzo registrazione</span>
            <strong>{seller.registrationAddress || "N/D"}</strong>
          </div>
        </div>

        <div className="seller-approval-card__actions">
          <button
            type="button"
            className="btn btn-primary seller-approval-card__approve"
            disabled={isUpdating || seller.isSellerApproved}
            onClick={() => this.onUpdateApproval(seller, true)}
          >
            {isUpdating ? "Aggiornamento..." : "Approva venditore"}
          </button>
          <button
            type="button"
            className="btn btn-outline-primary seller-approval-card__revoke"
            disabled={isUpdating || !seller.isSellerApproved}
            onClick={() => this.onUpdateApproval(seller, false)}
          >
            Disabilita
          </button>
        </div>
      </SurfaceCard>
    );
  };

  render() {
    return (
      <div className="seller-approvals-page">
        <PageHero
          eyebrow="Amministrazione"
          title="Approvazione venditori"
          description="Gestisci l'abilitazione finale degli account venditore registrati su Marketplace."
        />

        {this.state.error ? (
          <div className="alert alert-danger seller-approvals-feedback">
            {this.state.error}
          </div>
        ) : null}

        {this.state.isLoading ? (
          <SurfaceCard className="seller-approvals-empty">
            <strong>Caricamento venditori in corso...</strong>
          </SurfaceCard>
        ) : this.state.sellers.length === 0 ? (
          <SurfaceCard className="seller-approvals-empty">
            <strong>Nessun venditore da gestire</strong>
            <span>
              Quando arriveranno nuove registrazioni venditore compariranno qui.
            </span>
          </SurfaceCard>
        ) : (
          <div className="seller-approvals-grid">
            {this.state.sellers.map(this.renderSellerCard)}
          </div>
        )}
      </div>
    );
  }
}

export default SellerApprovals;

